export const heroStats = [
  { label: "今日同步线路", value: "12", unit: "条" },
  { label: "最近校验", value: "今早", unit: "09:20" },
  { label: "收录入口", value: "38", unit: "个" },
  { label: "版本更新", value: "v6.2", unit: "最新" },
];

export const entryCards = [
  {
    id: "main",
    icon: "ri-global-line",
    title: "官网主站入口",
    summary: "品牌与内容总入口，收录说明、公告与全部栏目，首次访问从这里开始。",
    tag: "主入口",
    hot: true,
  },
  {
    id: "latest",
    icon: "ri-link-m",
    title: "最新地址入口",
    summary: "与本页实时同步的可用域名，点击前先核对更新日期，避免进入过期地址。",
    tag: "实时同步",
    hot: true,
  },
  {
    id: "backup",
    icon: "ri-route-line",
    title: "备用线路入口",
    summary: "主站拥堵或维护时切换使用的备用通道，多线路轮换，保证随时可进。",
    tag: "多线路",
    hot: false,
  },
  {
    id: "app",
    icon: "ri-smartphone-line",
    title: "官方App下载",
    summary: "安卓与 iOS 客户端安装包说明，含版本号与适配要求，装完即可快捷进入。",
    tag: "客户端",
    hot: true,
  },
  {
    id: "desktop",
    icon: "ri-computer-line",
    title: "电脑版入口",
    summary: "桌面浏览器直达网页版，适合大屏浏览，无需安装任何额外插件。",
    tag: "网页版",
    hot: false,
  },
  {
    id: "mobile",
    icon: "ri-tablet-line",
    title: "移动端入口",
    summary: "针对手机浏览器优化的轻量版本，流量占用更小，加载更快。",
    tag: "轻量版",
    hot: false,
  },
];

export const lineStatus = [
  { id: "L1", name: "主线路一 · 华东", domain: "hq-01.91down.example", latency: "38ms", status: "可用", level: "good" },
  { id: "L2", name: "主线路二 · 华北", domain: "hq-02.91down.example", latency: "52ms", status: "可用", level: "good" },
  { id: "L3", name: "备用线路 · 华南", domain: "bk-01.91down.example", latency: "74ms", status: "可用", level: "warn" },
  { id: "L4", name: "备用线路 · 海外", domain: "bk-02.91down.example", latency: "168ms", status: "拥堵", level: "warn" },
  { id: "L5", name: "镜像线路 · 亚太", domain: "mirror.91down.example", latency: "—", status: "维护中", level: "bad" },
];

export const versionCollections = [
  {
    id: "android",
    title: "安卓客户端合集",
    summary: "适配主流安卓版本，含安装说明与权限清单，装前建议先看兼容列表。",
    tag: "Android",
    ver: "v6.2.1",
    updated: "10-10 更新",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20isometric%20smartphone%20with%20warm%20orange%20gradient%20blocks%20and%20soft%20cream%20background%2C%20stylized%20flat%20illustration%2C%20clean%20modern%20tech%20aesthetic%2C%20no%20text&width=900&height=700&seq=91down-android&orientation=squarish",
  },
  {
    id: "ios",
    title: "iOS 客户端合集",
    summary: "面向 iPhone 与 iPad，列出系统版本要求与描述文件安装步骤。",
    tag: "iOS",
    ver: "v5.9.4",
    updated: "10-08 更新",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20isometric%20tablet%20device%20with%20vermillion%20red%20accent%20shapes%20on%20warm%20cream%20backdrop%2C%20stylized%20flat%20illustration%2C%20minimal%20modern%20design%2C%20no%20text&width=900&height=700&seq=91down-ios&orientation=squarish",
  },
  {
    id: "pc",
    title: "电脑版合集",
    summary: "Windows 与 macOS 网页版直达与桌面快捷方式说明，无需安装包。",
    tag: "Desktop",
    ver: "v4.7.0",
    updated: "10-05 更新",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20isometric%20desktop%20monitor%20with%20olive%20green%20and%20amber%20geometric%20shapes%2C%20warm%20beige%20background%2C%20stylized%20flat%20illustration%2C%20clean%20editorial%20style%2C%20no%20text&width=900&height=700&seq=91down-pc&orientation=squarish",
  },
];

export const updateFeed = [
  {
    id: "u1",
    time: "10-10 09:20",
    title: "安卓客户端 v6.2.1 发布",
    summary: "修复了部分机型启动白屏的问题，同时把首页入口条加载速度提了一档。",
    tag: "安卓",
  },
  {
    id: "u2",
    time: "10-10 08:05",
    title: "主线路一完成例行校验",
    summary: "华东主线路延迟回落到 40ms 以内，可直接作为首选入口使用。",
    tag: "线路",
  },
  {
    id: "u3",
    time: "10-09 21:40",
    title: "备用线路·海外临时限流",
    summary: "该线路高峰时段会出现拥堵，建议优先切换华南备用线路。",
    tag: "提醒",
  },
  {
    id: "u4",
    time: "10-09 16:12",
    title: "新增镜像线路·亚太",
    summary: "面向亚太地区的镜像站点已上线，目前处于试运行维护窗口。",
    tag: "新增",
  },
  {
    id: "u5",
    time: "10-08 11:30",
    title: "iOS 描述文件安装说明更新",
    summary: "补充了新版系统下的信任设置路径截图，安装时按步骤逐步确认即可。",
    tag: "iOS",
  },
];

export const guideSteps = [
  {
    step: "01",
    title: "先核对更新条",
    summary: "进入本页后先看顶部更新条上的日期，确认你拿到的是当下同步的地址。",
  },
  {
    step: "02",
    title: "再挑一条可用线路",
    summary: "在线路状态里优先选「可用」且延迟低的线路，拥堵或维护中的先跳过。",
  },
  {
    step: "03",
    title: "选择对应终端入口",
    summary: "手机装 App、电脑走网页版，按自己的设备选入口，避免走错通道。",
  },
  {
    step: "04",
    title: "打不开就换线路",
    summary: "若某一入口无法连接，回到列表换一条线路即可，不必反复刷新同一地址。",
  },
];

export const faqItems = [
  {
    q: "91下载最新地址为什么总在变？",
    a: "域名会不定期做轮换与线路调整，本页的入口条与线路列表会同步更新。建议每次访问都先核对顶部的更新日期，再点对应入口即可。",
  },
  {
    q: "找不到入口时应该怎么办？",
    a: "优先使用本页的入口索引，它把官网主站、最新地址、备用线路和各类客户端都做了归类。若某条线路不可用，换列表中的其他可用线路即可，无需回到搜索引擎重新找。",
  },
  {
    q: "App 下载前需要确认哪些信息？",
    a: "先确认版本号与系统适配版本，再看客户端的更新日期。安卓与 iOS 的安装流程不同，iOS 通常还需要在设置里完成一次信任确认。",
  },
  {
    q: "电脑上可以直接使用吗？",
    a: "可以。桌面端走网页版入口即可，无需安装任何插件或客户端；如果你更习惯独立窗口，也可以为网页版创建桌面快捷方式。",
  },
  {
    q: "线路显示拥堵或维护中代表什么？",
    a: "拥堵通常是高峰时段访问量较大，稍后可能恢复；维护中则是该线路正在做例行调整。这两种情况都建议直接切换其他可用线路。",
  },
];

export const navLinks = [
  { id: "entry", label: "入口索引" },
  { id: "lines", label: "线路状态" },
  { id: "collections", label: "版本合集" },
  { id: "updates", label: "更新快讯" },
  { id: "guide", label: "下载指引" },
  { id: "faq", label: "常见问题" },
];